/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { ProfileService } from 'app/profile/services/profile.service';

export * from 'app/profile/services/profile.service';

export const services: any[] = [ProfileService];
